// Firebase configuration for Path Finder Fleet Management
import { getAnalytics, isSupported } from 'firebase/analytics';
import { Auth, getAuth as getFirebaseAuth } from 'firebase/auth';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { Firestore, getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAdGaq8ZgptWTes1l6-GGfur6TWLg894wA", // Temporarily disabled - replace with your actual API key
  authDomain: "pathfinder-8fba8.firebaseapp.com",
  projectId: "pathfinder-8fba8",
  storageBucket: "pathfinder-8fba8.firebasestorage.app",
  messagingSenderId: "654916158760",
  appId: "1:654916158760:web:a0efc29b334165d0177c1d",
  measurementId: "G-H924GKYB8YW"
};

// Initialize Firebase
let app: FirebaseApp | null = null;
let firestore: Firestore | null = null;
let auth: Auth | null = null;

try {
  app = initializeApp(firebaseConfig);
  firestore = getFirestore(app);
  auth = getFirebaseAuth(app);
} catch (error) {
  console.warn('Firebase initialization failed:', error);
  console.warn('Running in demo mode without Firebase');
}

// Function to get database instance with proper error handling
export function getDB(): Firestore {
  if (!firestore) {
    throw new Error('Firebase not initialized. Please check your configuration.');
  }
  return firestore;
}

// Function to get auth instance with proper error handling
export function getAuth(): Auth {
  if (!auth) {
    throw new Error('Firebase Auth not initialized. Please check your configuration.');
  }
  return auth;
}

// Export the database instance (for backward compatibility)
export const db = firestore;

// Initialize Analytics (only if supported and in browser)
let analytics;
if (typeof window !== 'undefined' && app) {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app!);
    }
  });
}

export { analytics };
export default app;
